export default "__VITE_ASSET__DEIEYZia__"